<template>
  <div
    class="live-push-list"
    :style="{ 'padding-top': currentTab == 0 ? '100px' : '160px' }"
  >
    <div class="header">
      <div class="title">家长心理健康教育直播课程</div>
      <el-tabs v-model="activeName" @tab-click="tabClick">
        <el-tab-pane label="直播房间列表" name="first"> </el-tab-pane>
        <el-tab-pane label="直播回放列表" name="second"> </el-tab-pane>
      </el-tabs>
      <el-select
        v-if="currentTab == 1"
        v-model="roomName"
        @change="roomChange"
        placeholder="请选择学段"
      >
        <el-option label="全部" :value="null"> </el-option>
        <el-option label="小学" value="小学"> </el-option>
        <el-option label="初中" value="初中"> </el-option>
        <el-option label="高中" value="高中"> </el-option>
        <div style="height: 20px"></div>
      </el-select>
    </div>
    <div
      v-show="currentTab == 0"
      class="live-list"
      element-loading-text="直播列表加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <div
        class="live-item"
        v-for="(item, index) in liveList"
        :key="index"
        @click="livePlayer(item)"
      >
        <div class="live-img">
          <span class="live-status" :class="'live-status-' + item.status">{{
            item.status ? (item.status == 1 ? "进行中" : "已结束") : "未开始"
          }}</span>
          <div class="live-name">
            <div class="name">
              <el-image
                src="/static/images/student_icon.png"
                mode=""
                class="live-icon"
              ></el-image>
              {{ item.roomName }}
            </div>
            <div class="speaker">主讲人:{{ item.liveDisplayName }}</div>
          </div>
          <el-image
            class="img"
            src="/static/images/zl.png"
            mode="aspectFill"
          ></el-image>
        </div>
        <div class="live-main">
          <div class="live-title">
            {{ item.liveTitle }}
          </div>
          <div class="live-content">
            {{ item.liveContent }}
          </div>
          <div class="live-time">
            <i class="el-icon-time"></i> 直播时间：{{
              $LYUtils.momentTime(item.liveTime, "YYYY-MM-DD HH:mm")
            }}
          </div>
        </div>
      </div>
    </div>

    <div
      v-show="currentTab == 1"
      class="live-list"
      element-loading-text="直播列表加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <div
        class="live-item"
        v-for="(item, index) in oldLiveList"
        :key="index"
        @click="livePlayer(item)"
      >
        <div class="live-img">
          <span class="live-status" :class="'live-status-' + item.status"
            >回放</span
          >
          <div class="live-name">
            <div class="name">
              <el-image
                src="/static/images/student_icon.png"
                mode=""
                class="live-icon"
              ></el-image>
              {{ item.roomName }}
            </div>
            <div class="speaker">主讲人:{{ item.liveDisplayName }}</div>
          </div>
          <el-image
            class="img"
            src="/static/images/zl.png"
            mode="aspectFill"
          ></el-image>
        </div>
        <div class="live-main">
          <div class="live-title">
            {{ item.liveTitle }}
          </div>
          <div class="live-content">
            {{ item.liveContent }}
          </div>
          <div class="live-time">
            <i class="el-icon-time"></i> 直播时间：{{
              $LYUtils.momentTime(item.liveTime, "YYYY-MM-DD HH:mm")
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: "first",
      spanStyle: {
        color: "#ffffff",
      },
      currentTab: 0,
      background: {
        background: "linear-gradient(45deg, #639af9, #7b97e8)",
      },
      roomName: null,
      liveList: [],
      oldLiveList: [],
    };
  },
  created() {
    this.getLiveList();
  },
  methods: {
    // tab 切换
    tabClick(item) {
      this.currentTab = item.index;
      if (this.oldLiveList.length == 0 && item.index == 1) {
        this.getOldLiveList();
      }
    },
    roomChange(item) {
      this.roomName = item;
      this.getOldLiveList();
    },
    // 获取直播间列表
    getLiveList() {
      this.loading = true;
      this.$axios
        .get("newSysSvr/psychological/liveRoom/listLiveRoom", {
          params: {
            type: this.currentTab,
            orderByColumn: "id",
            isAsc: "desc", // 倒叙desc // 正序asc
          },
        })
        .then((res) => {
          this.loading = false;

          if (res && res.rows && res.rows.length) {
            this.liveList = res.rows;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // 获取直播间列表
    getOldLiveList() {
      this.loading = true;
      this.$axios
        .get("newSysSvr/psychological/liveRoom/listLiveRoom", {
          params: {
            roomName: this.roomName,
            type: this.currentTab,
            orderByColumn: "liveTime",
            isAsc: "desc", // 倒叙desc // 正序asc
          },
        })
        .then((res) => {
          this.loading = false;

          if (res && res.rows && res.rows.length) {
            this.oldLiveList = res.rows;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    livePlayer(item) {
      this.updatePlayNumber(item); //更新浏览次数
      // return
      if (item.type == 1) {
        window.location.href = item.liveUrl;
      } else {
        if (item.status == 0) {
          this.$message.info("当前直播还未开始，请留意直播时间！");
        } else if (item.status == 1) {
          window.location.href = item.liveUrl;
        } else {
          this.$message.info("当前直播已结束！");
        }
      }
    },
    updatePlayNumber(item) {
      this.$axios.post("newSysSvr/psychological/liveRoom/updatePlayNum", {
        id: item.id,
      });
    },
  },
};
</script>
<style>
html,
body,
#app {
  height: 100%;
  width: 100%;
  min-width: 100px;
}
</style>
<style lang="less" scoped>
.live-push-list {
  width: 100%;
  padding-top: 100px;
  .header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: #fff;
    z-index: 999;
    box-shadow: 1px 1px 10px #dfdfdf;
  }
  .title {
    font-size: 16px;
    color: #fff;
    text-align: center;
    line-height: 40px;

    background: linear-gradient(45deg, rgb(99, 154, 249), rgb(123, 151, 232));
  }
  .live-list {
    padding-top: 20px;
    width: 100%;

    .live-item {
      padding: 5px 10px;
      display: flex;
      margin-bottom: 5px;
      align-items: flex-start;
      border-bottom: 1px solid #ddd;

      .live-img {
        position: relative;
        width: 110px;
        height: 95px;
        margin-right: 10px;

        .live-status {
          position: absolute;
          top: 0;
          right: 0px;
          padding: 2px 4px;
          font-size: 14px;
          z-index: 99;
          color: #fff;
          background-color: rgba(0, 0, 0, 0.1);
          border-radius: 0 20px 0 0;
        }

        .live-status-1 {
          color: #d1e90a;
        }

        .live-status-2 {
          color: #444444;
        }

        .live-name {
          position: absolute;
          left: 50%;
          top: 50%;
          width: 120px;
          text-align: center;
          z-index: 99;
          transform: translate(-50%, -50%);
          font-size: 18px;
          font-weight: 900;
          color: #fff;
          span-align: center;

          .name {
            display: flex;
            align-items: center;
            justify-content: center;

            .live-icon {
              width: 35px;
              height: 35px;
              margin-right: 10px;
            }
          }

          .speaker {
            font-size: 14px;
            font-weight: 500;
          }
        }

        .img {
          width: 110px;
          height: 80px;
          border-radius: 10px;
        }
      }

      .live-main {
        flex: 1;

        .live-title {
          font-weight: 600;
          font-size: 15px;
          overflow: hidden; //超出的文本隐藏
          span-overflow: ellipsis; //溢出用省略号显示
          white-space: nowrap; // 默认不换行；
        }

        .live-content {
          margin-top: 4px;
          color: #545454;
          font-size: 15px;
          overflow: hidden; //超出的文本隐藏
          display: -webkit-box;
          -webkit-line-clamp: 2; // 超出多少行
          -webkit-box-orient: vertical;
        }

        .live-time {
          color: #b38739;
          font-size: 14px;
        }
      }
    }
  }
}
@media (min-width: 800px) {
  .live-push-list {
    width: 100%;
    .title {
      font-size: 28px;
      color: #fff;
      text-align: center;
      line-height: 50px;
      span-align: center;
      background: linear-gradient(45deg, rgb(99, 154, 249), rgb(123, 151, 232));
    }
    .live-list {
      padding-top: 20px;
      width: 800px;
      margin: 0 auto;
      .live-item {
        padding: 20px;
        display: flex;
        margin-bottom: 20px;

        border-bottom: 1px solid #ddd;

        .live-img {
          position: relative;
          width: 250px;
          height: 170px;
          margin-right: 20px;

          .live-status {
            position: absolute;
            top: 0;
            right: 0;
            padding: 6px 8px;
            font-size: 24px;
            z-index: 99;
            color: #fff;
            background-color: rgba(0, 0, 0, 0.1);
            border-radius: 0 20px 0 0;
          }

          .live-status-1 {
            color: #d1e90a;
          }

          .live-status-2 {
            color: #444444;
          }

          .live-name {
            position: absolute;
            left: 50%;
            top: 50%;
            width: 100%;
            z-index: 99;
            transform: translate(-50%, -50%);
            font-size: 40px;
            font-weight: 900;
            color: #fff;
            span-align: center;

            .name {
              margin-top: 10px;
              display: flex;
              align-items: center;
              justify-content: center;

              .live-icon {
                width: 70px;
                height: 70px;
                margin-right: 10px;
              }
            }

            .speaker {
              font-size: 30px;
              font-weight: 500;
            }
          }

          .img {
            width: 250px;
            height: 160px;
            border-radius: 20px;
          }
        }

        .live-main {
          margin-top: 14px;
          flex: 1;

          .live-title {
            font-weight: 600;
            font-size: 32px;
            overflow: hidden; //超出的文本隐藏
            span-overflow: ellipsis; //溢出用省略号显示
            white-space: nowrap; // 默认不换行；
          }

          .live-content {
            margin-top: 4px;
            color: #545454;
            font-size: 28px;
            overflow: hidden; //超出的文本隐藏
            display: -webkit-box;
            -webkit-line-clamp: 2; // 超出多少行
            -webkit-box-orient: vertical;
          }

          .live-time {
            color: #b38739;
            font-size: 28px;
          }
        }
      }
    }
  }
}
</style>
<style >
.live-push-list .el-tabs__nav,
.live-push-list .el-tab {
  width: 100% !important;
}
.live-push-list .el-tabs__item,
.live-push-list .el-tab-pane {
  width: 50% !important;
}
.live-push-list .el-input__inner {
  border: none !important;
}
</style>


// WEBPACK FOOTER //
// src/views/live/liveList.vue